import SignInSide from "../Components/Login/SignInSide";

const Login = () => {
  return ( <SignInSide /> );
}
 
export default Login;